import { formatDistanceToNow } from 'date-fns';

export function getDataAndTime(timeStamp: string): string {
  return new Date(timeStamp).toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
}

export function toTitleCase(str: string) {
  return str.replace(
    /\w\S*/g,
    (text) => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
  );
}

export const getRelativeTime = (timestamp: number) => {
  return formatDistanceToNow(timestamp, { addSuffix: true });
};
